import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEditWishListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackEditWishList";

const useTrackEditWishList = (
    parameters: TrackEditWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.editWishList, parameters, options);
};

export default useTrackEditWishList;
